import React, { Children } from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

//Sanket Raut(21/7/2025)
// the user can only navigate to dashboard when they are loged in

const ConsultantPrivateRoute = ({ children }) => {

    const token = Cookies.get("ConsultantToken");

    if (!token) {
  return <Navigate to="/Consultant-Login" replace />;
   }

  return children;
};

export default ConsultantPrivateRoute;
